import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { RefreshCw, Save, Layout } from 'lucide-react';
import AskGBIntelligenceBar from '../components/statistiche/ai-briefings/AskGBIntelligenceBar';
import ExecutiveBriefWidget from '../components/statistiche/ai-briefings/widgets/ExecutiveBriefWidget';
import AlertAnomalieWidget from '../components/statistiche/ai-briefings/widgets/AlertAnomalieWidget';
import ProvePipelineWidget from '../components/statistiche/ai-briefings/widgets/ProvePipelineWidget';
import FunnelEcosistemaWidget from '../components/statistiche/ai-briefings/widgets/FunnelEcosistemaWidget';
import EconomiaPuntiWidget from '../components/statistiche/ai-briefings/widgets/EconomiaPuntiWidget';
import MarketplacePulseWidget from '../components/statistiche/ai-briefings/widgets/MarketplacePulseWidget';
import PartnerPerformanceWidget from '../components/statistiche/ai-briefings/widgets/PartnerPerformanceWidget';
import LMSPulseWidget from '../components/statistiche/ai-briefings/widgets/LMSPulseWidget';
import CommunityWidget from '../components/statistiche/ai-briefings/widgets/CommunityWidget';
import EventiChallengeWidget from '../components/statistiche/ai-briefings/widgets/EventiChallengeWidget';
import RetentionWidget from '../components/statistiche/ai-briefings/widgets/RetentionWidget';
import DataFreshnessWidget from '../components/statistiche/ai-briefings/widgets/DataFreshnessWidget';
type DateRange = 'today' | '7days' | '30days' | 'custom';
type Scope = 'all' | 'app' | 'lms' | 'partners' | 'events';
type UserSegment = 'all' | 'new' | 'active' | 'power' | 'inactive';
const AIBriefings = () => {
  // Global filters state
  const [dateRange, setDateRange] = useState<DateRange>('30days');
  const [scope, setScope] = useState<Scope>('all');
  const [userSegment, setUserSegment] = useState<UserSegment>('all');
  const [area, setArea] = useState('all');
  const [partner, setPartner] = useState('all');
  const [customDateFrom, setCustomDateFrom] = useState('');
  const [customDateTo, setCustomDateTo] = useState('');
  // Layout state
  const [layoutMode, setLayoutMode] = useState(false);
  const [hiddenWidgets, setHiddenWidgets] = useState<string[]>([]);
  const handleAsk = (question: string, detailed: boolean) => {
    console.log('Ask:', question, 'Detailed:', detailed);
    // TODO: Handle AI question
  };
  const handleUpdateBrief = () => {
    console.log('Update brief with current filters');
    // TODO: Refresh data
  };
  const handleSaveView = () => {
    const view = {
      filters: {
        dateRange,
        scope,
        userSegment,
        area,
        partner
      },
      hiddenWidgets,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('aiBriefingsView', JSON.stringify(view));
    console.log('View saved:', view);
  };
  const handleWidgetAsk = (widgetId: string, question: string) => {
    console.log(`Widget ${widgetId} asked:`, question);
    // TODO: Handle widget-specific question
  };
  const handleHideWidget = (widgetId: string) => {
    setHiddenWidgets([...hiddenWidgets, widgetId]);
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-1887">
      <div className="w-20 flex-shrink-0" data-id="element-1888">
        <Sidebar data-id="element-1889" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1890">
        <Topbar data-id="element-1891" />

        <main className="flex-1 overflow-y-auto" data-id="element-1892">
          {/* Fixed Header Section */}
          <div className="sticky top-0 z-30 bg-gray-50 border-b border-gray-200 shadow-sm" data-id="element-1893">
            <div className="p-4 md:p-6" data-id="element-1894">
              {/* Title and Actions */}
              <div className="flex items-center justify-between mb-4" data-id="element-1895">
                <div data-id="element-1896">
                  <h1 className="text-2xl font-bold text-gray-900" data-id="element-1897">
                    AI Briefings
                  </h1>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-1898">
                    Dashboard intelligente con insights e raccomandazioni AI
                  </p>
                </div>
                <div className="flex items-center gap-3" data-id="element-1899">
                  <button onClick={handleUpdateBrief} className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors" data-id="element-1900">
                    <RefreshCw className="h-4 w-4 mr-2" data-id="element-1901" />
                    Aggiorna brief
                  </button>
                  <button onClick={() => setLayoutMode(!layoutMode)} className={`inline-flex items-center px-4 py-2 border text-sm font-medium rounded-lg transition-colors ${layoutMode ? 'border-green-600 text-green-600 bg-green-50' : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'}`} data-id="element-1902">
                    <Layout className="h-4 w-4 mr-2" data-id="element-1903" />
                    {layoutMode ? 'Esci da layout' : 'Personalizza layout'}
                  </button>
                  <button onClick={handleSaveView} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium text-gray-700 bg-white rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1904">
                    <Save className="h-4 w-4 mr-2" data-id="element-1905" />
                    Salva vista
                  </button>
                </div>
              </div>

              {/* Global Filters */}
              <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4" data-id="element-1906">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3" data-id="element-1907">
                  {/* Date Range */}
                  <div data-id="element-1908">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1909">
                      Periodo
                    </label>
                    <select value={dateRange} onChange={e => setDateRange(e.target.value as DateRange)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1910">
                      <option value="today" data-id="element-1911">Oggi</option>
                      <option value="7days" data-id="element-1912">Ultimi 7 giorni</option>
                      <option value="30days" data-id="element-1913">Ultimi 30 giorni</option>
                      <option value="custom" data-id="element-1914">Personalizzato</option>
                    </select>
                  </div>

                  {/* Scope */}
                  <div data-id="element-1915">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1916">
                      Ambito
                    </label>
                    <select value={scope} onChange={e => setScope(e.target.value as Scope)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1917">
                      <option value="all" data-id="element-1918">Tutto</option>
                      <option value="app" data-id="element-1919">App</option>
                      <option value="lms" data-id="element-1920">LMS</option>
                      <option value="partners" data-id="element-1921">Partners</option>
                      <option value="events" data-id="element-1922">Eventi & Challenge</option>
                    </select>
                  </div>

                  {/* User Segment */}
                  <div data-id="element-1923">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1924">
                      Segmento Utenti
                    </label>
                    <select value={userSegment} onChange={e => setUserSegment(e.target.value as UserSegment)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1925">
                      <option value="all" data-id="element-1926">Tutti</option>
                      <option value="new" data-id="element-1927">Nuovi</option>
                      <option value="active" data-id="element-1928">Attivi</option>
                      <option value="power" data-id="element-1929">Power users</option>
                      <option value="inactive" data-id="element-1930">Inattivi</option>
                    </select>
                  </div>

                  {/* Area */}
                  <div data-id="element-1931">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1932">
                      Area
                    </label>
                    <select value={area} onChange={e => setArea(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1933">
                      <option value="all" data-id="element-1934">Tutte</option>
                      <option value="nord" data-id="element-1935">Nord</option>
                      <option value="centro" data-id="element-1936">Centro</option>
                      <option value="sud" data-id="element-1937">Sud</option>
                    </select>
                  </div>

                  {/* Partner */}
                  <div data-id="element-1938">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1939">
                      Partner
                    </label>
                    <select value={partner} onChange={e => setPartner(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1940">
                      <option value="all" data-id="element-1941">Tutti</option>
                      <option value="naturasi" data-id="element-1942">NaturaSì</option>
                      <option value="lasaponaria" data-id="element-1943">La Saponaria</option>
                      <option value="biosapori" data-id="element-1944">BioSapori</option>
                    </select>
                  </div>
                </div>

                {/* Custom Date Range */}
                {dateRange === 'custom' && <div className="grid grid-cols-2 gap-3 mt-3" data-id="element-1945">
                    <div data-id="element-1946">
                      <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1947">
                        Da
                      </label>
                      <input type="date" value={customDateFrom} onChange={e => setCustomDateFrom(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1948" />
                    </div>
                    <div data-id="element-1949">
                      <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1950">
                        A
                      </label>
                      <input type="date" value={customDateTo} onChange={e => setCustomDateTo(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" data-id="element-1951" />
                    </div>
                  </div>}
              </div>

              {/* Ask GB Intelligence Bar */}
              <AskGBIntelligenceBar onAsk={handleAsk} data-id="element-1952" />
            </div>
          </div>

          {/* Main Content Area - Widgets Bento Grid */}
          <div className="p-4 md:p-6" data-id="element-1953">
            <div className="grid grid-cols-12 gap-4" data-id="element-1954">
              {/* Row 1 */}
              {!hiddenWidgets.includes('executive-brief') && <ExecutiveBriefWidget onExpand={() => console.log('Expand Executive Brief')} onHide={() => handleHideWidget('executive-brief')} onAsk={q => handleWidgetAsk('executive-brief', q)} data-id="element-1955" />}

              {!hiddenWidgets.includes('alert-anomalie') && <AlertAnomalieWidget onHide={() => handleHideWidget('alert-anomalie')} onAsk={q => handleWidgetAsk('alert-anomalie', q)} data-id="element-1956" />}

              {/* Row 2 */}
              {!hiddenWidgets.includes('funnel-ecosistema') && <FunnelEcosistemaWidget onExpand={() => console.log('Expand Funnel')} onHide={() => handleHideWidget('funnel-ecosistema')} onAsk={q => handleWidgetAsk('funnel-ecosistema', q)} data-id="element-1957" />}

              {!hiddenWidgets.includes('economia-punti') && <EconomiaPuntiWidget onHide={() => handleHideWidget('economia-punti')} onAsk={q => handleWidgetAsk('economia-punti', q)} data-id="element-1958" />}

              {/* Row 3 */}
              {!hiddenWidgets.includes('prove-pipeline') && <ProvePipelineWidget onExpand={() => console.log('Expand Prove Pipeline')} onHide={() => handleHideWidget('prove-pipeline')} onAsk={q => handleWidgetAsk('prove-pipeline', q)} data-id="element-1959" />}

              {!hiddenWidgets.includes('marketplace-pulse') && <MarketplacePulseWidget onHide={() => handleHideWidget('marketplace-pulse')} onAsk={q => handleWidgetAsk('marketplace-pulse', q)} data-id="element-1960" />}

              {/* Row 4 */}
              {!hiddenWidgets.includes('partner-performance') && <PartnerPerformanceWidget onHide={() => handleHideWidget('partner-performance')} onAsk={q => handleWidgetAsk('partner-performance', q)} data-id="element-1961" />}

              {!hiddenWidgets.includes('lms-pulse') && <LMSPulseWidget onExpand={() => console.log('Expand LMS Pulse')} onHide={() => handleHideWidget('lms-pulse')} onAsk={q => handleWidgetAsk('lms-pulse', q)} data-id="element-1962" />}

              {/* Row 5 */}
              {!hiddenWidgets.includes('community') && <CommunityWidget onHide={() => handleHideWidget('community')} onAsk={q => handleWidgetAsk('community', q)} data-id="element-1963" />}

              {!hiddenWidgets.includes('eventi-challenge') && <EventiChallengeWidget onHide={() => handleHideWidget('eventi-challenge')} onAsk={q => handleWidgetAsk('eventi-challenge', q)} data-id="element-1964" />}

              {!hiddenWidgets.includes('retention') && <RetentionWidget onExpand={() => console.log('Expand Retention')} onHide={() => handleHideWidget('retention')} onAsk={q => handleWidgetAsk('retention', q)} data-id="element-1965" />}

              {/* Row 6 */}
              {!hiddenWidgets.includes('data-freshness') && <DataFreshnessWidget onHide={() => handleHideWidget('data-freshness')} data-id="element-1966" />}
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default AIBriefings;